import React from 'react';
// components
import Dropdown from 'react-bootstrap/Dropdown';
import HeaderGlobal from './HeaderGlobal';
import HeaderDropdown from './HeaderDropdown';
import Image from '../image/Image';
import CustomLink from '../custom-link/CustomLink';
import SearchForm from '../search-form/SearchForm';
import { sharedLogosPath } from '../../scripts/data';
// data
import menus from './header-content';
import { IMenu, menuIdNames } from './header-interfaces';
import { pageType } from '../../interfaces';

type HeaderFullProps = {
  homepage?: boolean;
  pageType: pageType;
};
type HeaderFullState = {
  isMobileToggleOn: boolean;
  showOverlay: boolean;
  mobSubMenu: boolean;
  rpt: boolean;
  itp: boolean;
  crd: boolean;
  lns: boolean;
  aut: boolean;
  mon: boolean;
  searchDrp: boolean;
};
export default class HeaderFull extends React.Component<HeaderFullProps, HeaderFullState> {
  constructor(props: HeaderFullProps) {
    super(props);
    this.state = {
      isMobileToggleOn: false,
      showOverlay: false,
      mobSubMenu: false,
      rpt: false,
      itp: false,
      crd: false,
      lns: false,
      aut: false,
      mon: false,
      searchDrp: false
    };
  }

  handleNavToggleClick = () => {
    this.closeAllNavDropdowns();
    this.setState(() => ({
      mobSubMenu: false
    }));
    this.setState((prevState) => ({
      isMobileToggleOn: !prevState.isMobileToggleOn
    }));
  };

  checkOverlay = () => {
    let state = false;
    menus.forEach((st: IMenu) => {
      const { id } = st;
      if (this.state[id]) {
        state = true;
      }
    });
    return state;
  };

  setToggleDropdown = (state: menuIdNames) => {
    this.setState((prevState) => ({
      mobSubMenu: !prevState[state]
    }));
    this.setState(
      (prevState) =>
        ({
          [state]: !prevState[state]
        }) as Pick<HeaderFullState, keyof HeaderFullState>,
      () => {
        this.showOverlay(this.checkOverlay());
      }
    );
    // to close search dropdown on desktop if open
    if (this.state.searchDrp) {
      this.setState(() => ({
        searchDrp: false
      }));
    }
  };

  closeAllNavDropdowns(id?: menuIdNames) {
    if (!id) {
      this.showOverlay(false);
    }
    menus.forEach((st: IMenu) => {
      if (!id || st.id !== id) {
        this.setState({
          [st.id]: false
        } as Pick<HeaderFullState, keyof HeaderFullState>);
      }
    });
  }

  showOverlay(statement: boolean) {
    this.setState(() => ({
      showOverlay: statement
    }));
  }

  render() {
    return (
      <>
        <div
          id="nav-overlay"
          className={`${this.state.showOverlay ? 'overlay' : ''}`}
        />
        <header
          id="header"
          className={`${this.state.isMobileToggleOn ? 'mob-open' : ''} ${
            this.state.mobSubMenu ? 'mob-sub-open' : ''
          }`}>
          <div className="container d-flex justify-content-between align-items-center nav-mobile d-lg-none py-2">
            <CustomLink
              isLink={this.props.pageType === 'product'}
              href="/"
              className="exp-logo">
              <Image
                src={`${sharedLogosPath}/logo-experian.svg`}
                alt="Experian logo."
                width="111"
                height="38"
              />
            </CustomLink>
            <div>
              <a
                href="/help/login.html"
                data-link-both="nav-public-header-signin">
                Sign In
              </a>
              <button
                type="button"
                aria-label="Open navigation"
                className="btn nav-toggle ecs-font-icon-nav-menu py-0 pe-0"
                aria-expanded="false"
                aria-controls="nav-full"
                data-link-both="nav-public-header-menudropdownopen"
                onClick={this.handleNavToggleClick}
              />
            </div>
          </div>
          <nav
            id="nav-full"
            className="d-flex flex-lg-wrap flex-column flex-lg-row align-items-start">
            <div className="container justify-content-between mobile-top-search order-1 py-3 border-bottom d-lg-none w-100 align-self-start align-self-lg-baseline align-items-start">
              <button
                type="button"
                className="nav-toggle btn order-2 ecs-font-icon-act-close py-0 pe-0"
                aria-controls="nav-full"
                aria-label="Close navigation"
                aria-expanded="true"
                data-link-both="nav-public-header-menudropdownclose"
                onClick={this.handleNavToggleClick}
              />
              <SearchForm
                toShowCopyOnFocus
                ifFocusableOnLoad={false}
                className="rounded-2 order-1 flex-fill w-100"
                id="nav-full-search"
                homepage={this.props.homepage}
              />
            </div>
            <div
              id="main-navigation"
              className="w-100 align-self-lg-baseline order-2">
              <div className="container">
                <a
                  href="#main"
                  className="visually-hidden-focusable bg-white p-0 m-0 position-absolute">
                  Skip to main content
                </a>
                <div className="col d-lg-flex justify-content-lg-between align-items-lg-center position-relative">
                  <div className="d-lg-flex align-items-lg-center">
                    <CustomLink
                      isLink={this.props.pageType === 'product'}
                      className="me-lg-4 exp-logo"
                      href="/">
                      <Image
                        src={`${sharedLogosPath}/logo-experian.svg`}
                        alt="Experian logo."
                        width="145"
                        height="49"
                      />
                    </CustomLink>
                    <ul className="main-nav-1 d-flex flex-wrap flex-lg-nowrap mb-0 ps-0">
                      {menus.map((menu) => (
                        <li key={`header-${menu.id}-li`}>
                          <Dropdown
                            show={this.state[menu.id]}
                            autoClose="outside"
                            className="position-static"
                            focusFirstItemOnShow="keyboard"
                            onToggle={() => {
                              this.setToggleDropdown(menu.id);
                            }}>
                            <Dropdown.Toggle
                              as="button"
                              id={menu.id}
                              type="button"
                              aria-label={menu.tabName}
                              className={`${
                                this.state[menu.id] ? 'active-link' : ''
                              } m-n-link btn-reset`}
                              onClick={() => {
                                this.setToggleDropdown(menu.id);
                              }}
                              data-link-both={menu.dataLinkBoth}>
                              {menu.tabName}
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align={{ lg: 'end' }}
                              renderOnMount
                              aria-labelledby={menu.id}>
                              <HeaderDropdown
                                pageType={this.props.pageType}
                                menu={menu}
                                backToMenu={this.setToggleDropdown}
                              />
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="main-nav-2 d-none d-lg-flex align-items-lg-center">
                    <a
                      href="/help/login.html"
                      data-link-both="nav-public-header-signin"
                      className="login">
                      Sign In
                    </a>
                    <Dropdown
                      autoClose="outside"
                      show={this.state.searchDrp}
                      onToggle={() => {
                        this.setState((prevState) => ({
                          searchDrp: !prevState.searchDrp
                        }));
                      }}>
                      <Dropdown.Toggle
                        variant="button"
                        id="header-search-toggle"
                        aria-label="Search."
                        className="m-0 p-0 text-decoration-none search-btn"
                      />
                      <Dropdown.Menu
                        align={{ lg: 'end' }}
                        className="mt-3"
                        aria-labelledby="header-search-toggle">
                        <SearchForm
                          toShowCopyOnFocus={false}
                          ifFocusableOnLoad
                          id="nav-drp-search"
                          homepage={this.props.homepage}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
            <HeaderGlobal
              homepage={this.props.homepage}
              pageType={this.props.pageType}
            />
          </nav>
        </header>
      </>
    );
  }
}
